import { api } from '../../../lib/api'

export const UNPUBLISH_PRODUCT_REQUEST = 'UNPUBLISH_PRODUCT_REQUEST'
export const UNPUBLISH_PRODUCT_SUCCESS = 'UNPUBLISH_PRODUCT_SUCCESS'
export const UNPUBLISH_PRODUCT_FAILED = 'UNPUBLISH_PRODUCT_FAILED'

export const unPublishProduct = function (productId) {
  return function (dispatch) {
    dispatch({
      type: UNPUBLISH_PRODUCT_REQUEST
    })
    api.unPublishProduct(productId).then(unPublishProductResponse => {
      dispatch({
        type: UNPUBLISH_PRODUCT_SUCCESS,
        payload: unPublishProductResponse
      })
    }).catch(error => {
      dispatch({
        type: UNPUBLISH_PRODUCT_FAILED,
        error
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/product/unpublish-product.js